export default "__VITE_ASSET__Cod_MSJn__"